import { useMutation } from "react-query";

import type { BaseEnrollmentGoal, PutEnrollmentGoalArgs } from "api/services/admin/schemas";
import { useApiClient } from "api/useApiClient";

export const usePutEnrollmentGoal = () => {
  const client = useApiClient();

  return useMutation<BaseEnrollmentGoal, Error, PutEnrollmentGoalArgs>({
    mutationFn: args => client.putEnrollmentGoal(args),
  });
};
